<script lang="ts">
  import { paramsService, antecedentsService } from '../services';
  import type { Param } from '../Model/Param';

  export let antecedentSelectId: string;
  export let antecedentSelectName: string = '';
  let antecedentsShow: Param[] = [];
  let params: Param[];


  load();

  async function load() {

    params = await paramsService.findByType('antecedentType');

    for (const param of params) {
        antecedentsShow.push(param);
    }

    antecedentsShow.sort((a, b) => {
      return a.name < b.name ? -1 : 1;
    });

    antecedentsShow = antecedentsShow;
  }

  function actName(e: any) {
    let [antecedent] = antecedentsShow.filter(p => p.id == e.srcElement.value)
    antecedentSelectName = antecedent.name;
  }

</script>

{#if antecedentsShow}
  <div class="input-group">
    <select class="form-select" bind:value={antecedentSelectId} on:change={actName}>
      {#each antecedentsShow as antecedent}
        <option value={antecedent.id}>{antecedent.name}</option>
      {/each}
    </select>
  </div>
{/if}

<style>
</style>
